import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import { Formik } from "formik";

import { Api } from "../../../../services/api";
import { DragAndDrop } from "../../../../components/DragAndDrop";
import { TopSaveWrapper, Container } from "../formComponents.styles";
import {
  BlueButton,
  OutlineButton,
  SaveButtonContainer,
  StyledForm,
} from "../../Admin.styles";
import { textTheme } from "../../../../theme";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;
`;

const DnDContainer = styled.div``;

const Content = styled.div`
  display: flex;
`;

const Error = styled.div`
  padding-right: 10px;
  align-self: flex-end;
  ${textTheme.subtitle2};
  color: #f7685b;
`;

export const StrengthsFinder: React.FC<{}> = () => {
  const history = useHistory();
  const { memberId } = useParams<{ memberId: string }>();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [themes, setThemes] = useState<any>({
    topThemes: [],
    availableThemes: [],
    submissionMessage: "",
  });

  useEffect(() => {
    fetchThemes();
    setDataLoaded(true);
  }, []);

  const fetchThemes = async () => {
    try {
      const availableThemes = await Api.members.getStrengthFinderAttributes();
      const topThemes = await Api.members.getMemberDetails(memberId);

      const topThemeIDs: string[] = [];
      topThemes?.data?.employmentInfo?.strengthFinderAttributes?.map(
        (theme: any) => topThemeIDs.push(theme.attributeId)
      );

      const newTopThemes: any = [];
      availableThemes.data.map((theme: any) => {
        if (topThemeIDs.includes(theme.id)) {
          newTopThemes.push(theme);
        }
      });
      const newAvailableThemes = availableThemes.data.filter((theme: any) => {
        return !topThemeIDs.includes(theme.id);
      });

      newTopThemes.map((newTopTheme: any) => {
        topThemes?.data?.employmentInfo?.strengthFinderAttributes?.map(
          (topTheme: any) => {
            if (newTopTheme.id === topTheme.attributeId) {
              newTopTheme.position = topTheme.position;
            }
          }
        );
      });

      const newThemes = {
        topThemes: newTopThemes.sort(
          (a: any, b: any) => a.position - b.position
        ),
        availableThemes: newAvailableThemes.sort((a: any, b: any) =>
          a.themeGroup > b.themeGroup ? 1 : b.themeGroup > a.themeGroup ? -1 : 0
        ),
      };

      setThemes(newThemes);
    } catch (error) {
      console.error("Fetch Strengthsfinder Themes:", error);
    }
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type="submit">Save</BlueButton>
      <OutlineButton
        type="button"
        onClick={() => history.push("/admin/member")}
      >
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  const submitValues = async () => {
    if (themes.topThemes.length < 5)
      return setThemes({
        ...themes,
        errors: "Must select 5 StrengthsFinder themes!",
      });

    const formattedThemes: any = { strengthFinderAttributes: [] };
    await themes.topThemes.forEach((theme: any, idx: number) => {
      formattedThemes.strengthFinderAttributes.push({
        attributeId: theme.id,
        position: idx + 1,
      });
    });

    try {
      await Api.members.updateStrengthFinderAttributes(
        memberId,
        formattedThemes
      );
      history.push(`/admin/members/${memberId}/personalInformation`);
    } catch (e) {
      console.error("Update StrengthFinder Themes:", e);
    }
  };

  return (
    <Container>
      {dataLoaded && (
        <Formik
          initialValues={{ strengthFinderAttributes: [] }}
          onSubmit={submitValues}
        >
          <StyledForm>
            <Header>
              <TopSaveWrapper>
                <Content>
                  <Error>{themes.errors}</Error>
                  {SaveButtons}
                </Content>
              </TopSaveWrapper>
            </Header>
            <DnDContainer>
              <DragAndDrop data={themes} />
            </DnDContainer>
          </StyledForm>
        </Formik>
      )}
    </Container>
  );
};
